import styles from './EmptyState.module.css';

/**
 * EmptyState
 * ──────────
 * Shown inside tables or page sections when there's no data.
 *
 * @param {string}    message  Primary message e.g. "No pledges found."
 * @param {string}    [hint]   Secondary hint text
 * @param {ReactNode} [action] Optional CTA button
 *
 * Usage (in table td):
 *   {items.length === 0 && (
 *     <tr>
 *       <td colSpan={9}>
 *         <EmptyState message={TABLE.noResults(ENTITIES.pledge)} />
 *       </td>
 *     </tr>
 *   )}
 *
 * Usage (standalone):
 *   <EmptyState
 *     message={EMPTY.noData(ENTITIES.pledge)}
 *     action={<button onClick={openForm}>New Pledge</button>}
 *   />
 */
export default function EmptyState({ message, hint, action }) {
  return (
    <div className={styles.wrap}>
      <p className={styles.message}>{message}</p>
      {hint && <p className={styles.hint}>{hint}</p>}
      {action && <div className={styles.action}>{action}</div>}
    </div>
  );
}
